import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import StandardLayout from './StandardLayout'

import { ChildProps } from '~/common/define/props'
import { RequestError } from '~/common/define/requestError'
import { GetError } from '~/modules/error/selectors'
import { AppContext } from '~/common/context/AppContext'
import LoginLayoutPage from '~/components/page/login/LoginLayoutPage'
import ErrorLayoutPage from '~/components/page/error/ErrorLayoutPage'

const makeAppErrorLayout = (error: RequestError, hasAccessToken: boolean) => {

  if (!hasAccessToken) {
    return (
      <LoginLayoutPage redirect/>
    )
  }

  if (error) {
    return <ErrorLayoutPage error={error} />
  }

  return null
}

interface Props extends ChildProps {
  reqError?: RequestError
}

const AppLayout = ({children, reqError = null}: Props) => {
  const error: RequestError = useSelector(GetError)
  const context = useContext(AppContext)
  const errorLayout = makeAppErrorLayout(error ?? reqError, context.hasAccessToken)
  if (errorLayout) {
    return errorLayout
  }

  return (
    <StandardLayout>
      {children}
    </StandardLayout>
  )
}

export default AppLayout